import React from 'react';
import BaseHeader from './BaseHeader';
import { NativeStackHeaderProps } from '@react-navigation/native-stack';

export type StandardHeaderOwnProps = {};

export type StandardHeaderProps = StandardHeaderOwnProps & NativeStackHeaderProps;

const StandardHeader: React.FC<StandardHeaderProps> = (props) => {
    return <BaseHeader height={60} {...props} />;
};

export default React.memo(StandardHeader);
